// Animated particles for background
export const createParticles = () => {
  const particles = [];
  const count = 50;
  
  for (let i = 0; i < count; i++) {
    particles.push({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 20 + 10,
      delay: Math.random() * 5
    });
  }
  
  return particles;
};
